class CustomCardsSlider extends HTMLElement {
  constructor() {
    super();
    const slider = this;
    var flkty = new Flickity( slider, {
      wrapAround: true,
      cellAlign: 'center',
      autoPlay: 3000
    });

    var parent = slider.closest('.about-us-images-section');
    var sectionTitle = parent.querySelector('h2');
    if (sectionTitle != null) {
      sectionTitle.innerHTML = flkty.selectedElement.getAttribute('data-title');
      flkty.on('change', function(index) {
        sectionTitle.innerHTML = flkty.selectedElement.getAttribute('data-title');
      });
    }
  }
}

customElements.define('custom-images-slider', CustomCardsSlider);

